// Animación de contador
/**
 * @param {Element} el
 * @param {number} start
 * @param {number} end
 * @param {number} duration
 */
const animateValue = (el, start, end, duration) => {
    /** @type {number | null} */
    let startTimestamp = null;
    /** @param {number} timestamp */
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        el.textContent = String(Math.floor(progress * (end - start) + start));
        if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
};

// Observer para animaciones
if ('IntersectionObserver' in window) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /** @type {HTMLElement | null} */
    const aboutRoot = document.querySelector("#MainContent[data-template='page.sobre-nosotros']");
    const scope = aboutRoot || document;

    const animatedEls = Array.from(scope.querySelectorAll('.animate-on-scroll'));
    if (!animatedEls.length) {
        // Nothing to animate
    } else if (prefersReducedMotion) {
        // Keep it simple: just show everything with no motion.
        animatedEls.forEach((el) => el.classList.add('in-view'));
    } else {
        const observerOptions = { threshold: 0.15, rootMargin: '0px 0px -12% 0px' };
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (!entry.isIntersecting) continue;

                /** @type {HTMLElement} */
                const target = /** @type {HTMLElement} */ (entry.target);
                target.classList.add('in-view');

                // Animar contadores (una sola vez)
                if (target.classList.contains('cta-stats') && !target.hasAttribute('data-counted')) {
                    target.setAttribute('data-counted', 'true');
                    target.querySelectorAll('.stat-value[data-value]').forEach((el) => {
                        const raw = el.getAttribute('data-value');
                        const value = raw ? parseInt(raw, 10) : NaN;
                        if (!Number.isFinite(value)) return;
                        animateValue(el, 0, value, 2000);
                    });
                }

                observer.unobserve(target);
            }
        }, observerOptions);

        // Pre-mark anything already visible so we don't flash-hide above the fold.
        for (const el of animatedEls) {
            const rect = el.getBoundingClientRect();
            const inViewport = rect.top < window.innerHeight * 0.9 && rect.bottom > 0;
            if (inViewport) el.classList.add('in-view');
        }

        document.documentElement.classList.add('skull-aos');

        animatedEls.filter((el) => !el.classList.contains('in-view')).forEach((el) => observer.observe(el));
    }
}

// Estilos de animación
if (!document.getElementById('skull-about-animate-on-scroll-styles')) {
    const style = document.createElement('style');
    style.id = 'skull-about-animate-on-scroll-styles';
    style.textContent = `
        /*
            About page scroll reveals.
            Uses translate (not transform) so it won't fight with hover transforms on cards/images.
            Only activates after JS sets html.skull-aos (prevents content staying invisible if JS fails).
        */
        html.skull-aos #MainContent[data-template='page.sobre-nosotros'] .animate-on-scroll {
            opacity: 0;
            translate: 0 24px;
            transition: opacity 0.55s ease-out, translate 0.55s ease-out;
            will-change: opacity, translate;
        }
        html.skull-aos #MainContent[data-template='page.sobre-nosotros'] .animate-on-scroll.in-view {
            opacity: 1;
            translate: 0 0;
        }

        @media (prefers-reduced-motion: reduce) {
            html.skull-aos #MainContent[data-template='page.sobre-nosotros'] .animate-on-scroll {
                opacity: 1;
                translate: 0 0;
                transition: none;
            }
        }

        @supports not (translate: 0 1px) {
            html.skull-aos #MainContent[data-template='page.sobre-nosotros'] .animate-on-scroll {
                transform: translateY(24px);
                transition: opacity 0.55s ease-out, transform 0.55s ease-out;
            }
            html.skull-aos #MainContent[data-template='page.sobre-nosotros'] .animate-on-scroll.in-view {
                transform: translateY(0);
            }
        }
`;
    document.head.appendChild(style);
}
